import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "gift-outline" }), /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 3,
				y: 8,
				width: 18,
				height: 4,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("path", { d: "M4.5 12v7a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-7M12 8v12.5" }),
			/* @__PURE__ */ _jsx("path", { d: "M12 8H9a3 3 0 1 1 3-3v3ZM12 8h3a3 3 0 1 0-3-3v3Z" })
		]
	})]
});
export default SvgGiftOutline;
